import { useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import { useToast } from "@/hooks/use-toast";
import { Lead } from "../types";

export const useLeadActions = (lead: Lead, onLeadUpdated?: () => void) => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [isEditDialogOpen, setIsEditDialogOpen] = useState(false);
  const [editedLead, setEditedLead] = useState(lead);
  const { toast } = useToast();

  const handleDelete = async () => {
    try {
      const { error } = await supabase
        .from('quote_leads')
        .delete()
        .eq('id', lead.id);

      if (error) throw error;

      toast({
        title: "Success",
        description: "Lead deleted successfully",
      });
      
      if (onLeadUpdated) onLeadUpdated();
    } catch (error: any) {
      console.error('Error deleting lead:', error);
      toast({
        variant: "destructive",
        title: "Error",
        description: error.message || "Failed to delete lead",
      });
    }
  };

  const handleEditSubmit = async () => {
    try {
      const { error } = await supabase
        .from('quote_leads')
        .update({
          first_name: editedLead.first_name,
          last_name: editedLead.last_name,
          email: editedLead.email,
          phone: editedLead.phone,
          insurance_type: editedLead.insurance_type,
          quoted_amount: editedLead.quoted_amount,
          street: editedLead.street,
          city: editedLead.city,
          state: editedLead.state,
          zip_code: editedLead.zip_code,
          pipeline_stage: editedLead.pipeline_stage,
          lead_source: editedLead.lead_source
        })
        .eq('id', lead.id);

      if (error) throw error;

      toast({
        title: "Success",
        description: "Lead updated successfully",
      });
      
      setIsEditDialogOpen(false);
      if (onLeadUpdated) onLeadUpdated();
    } catch (error: any) {
      console.error('Error updating lead:', error);
      toast({
        variant: "destructive",
        title: "Error",
        description: error.message || "Failed to update lead",
      });
    }
  };

  return {
    isDialogOpen,
    setIsDialogOpen,
    isEditDialogOpen,
    setIsEditDialogOpen,
    editedLead,
    setEditedLead,
    handleDelete,
    handleEditSubmit,
  };
};